module.exports = __webpack_public_path__ + "static/media/ZensTabletLogo.9804bbe3.png";